// src/components/CustomCard/CustomCardTitle.tsx
import React from "react";

interface CustomCardTitleProps {
  children: React.ReactNode;
  className?: string;
}

const CustomCardTitle: React.FC<CustomCardTitleProps> = ({
  children,
  className = "",
}) => <h2 className={`custom-card-title ${className}`}>{children}</h2>;

export default CustomCardTitle;
